/**
 * Centralized Asset URLs for Gam Ticket
 * 
 * UPDATE THESE URLs when you host assets on your own server/CDN
 * Currently using Emergent CDN - replace with your own hosting
 */

// Main Logo - Circular Gam Ticket logo
export const GAM_TICKET_LOGO = 'https://customer-assets.emergentagent.com/job_gambia-entry/artifacts/2s334ty8_ChatGPT%20Image%20Mar%2024%2C%202026%2C%2005_06_45%20PM.png';

// Hero/Background Images
export const HERO_BG = 'https://customer-assets.emergentagent.com/job_gambia-entry/artifacts/rw3y82vp_IMG_5334%20%281%29.jpeg';
export const STADIUM_BG = 'https://customer-assets.emergentagent.com/job_gambia-entry/artifacts/jy7p2i9c_485357818_987561343473939_5914527688038324528_n.jpg';

// Payment Provider Logos
export const WAVE_LOGO = 'https://customer-assets.emergentagent.com/job_gambia-entry/artifacts/k97cz6u7_unnamed.png';
export const YONNA_LOGO = 'https://customer-assets.emergentagent.com/job_gambia-entry/artifacts/o5vabvbq_unnamed%20%281%29.png';

// Site Configuration
export const SITE_URL = 'https://gamticket.com';
export const SITE_NAME = 'Gam Ticket';
export const SITE_TAGLINE = 'The Premier Ticketing Platform for The Gambia';

// Contact Info
export const CONTACT_EMAIL = 'gamticket1@gmail.com';
export const CONTACT_PHONE = '+220 316 7303';
